var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.account.user && _vm.parent)?_c('header',[_c('Menu')],1):_vm._e(),(_vm.parent)?_c('main',[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('Alert'),_vm._t("default")],2)])]):_vm._e(),(!_vm.parent)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }